import React from "react";
import { Column } from "@ant-design/plots";
import { formatCurrency } from "../../utils/formatCurrency";

const ColumnChartLand = (props) => {
  const config = {
    data: props.data,
    xField: "type",
    yField: "value",
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 1,
      },
      formatter: (datum) => `${formatCurrency(datum.value)}`,
    },
    color: ({ type }) => {
      switch (type) {
        case "Disponíveis":
          return "#20B2AA";
        case "Vendidos":
          return "#f5222d";
        default:
          return "#d9d9d9";
      }
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    yAxis: {
      label: {
        formatter: (value) => formatCurrency(value),
      },
    },
    meta: {
      type: {
        alias: "",
      },
      sales: {
        alias: "",
      },
    },
    tooltip: {
      formatter: (datum) => {
        return {
          name: datum.type,
          value: formatCurrency(datum.value),
        };
      },
    },
    animation: false,
    height: 200,
  };
  return <Column {...config} />;
};

export default ColumnChartLand;
